import React from 'react';
import { IconButton, ListItemIcon, MenuItem } from '@mui/material';

/** Interface for the header's action props.  */
interface IHeaderActionItemProps {
    buttonId?: string;
    title: string;
    onClick: () => void;
    onClose?: () => void;
    icon?: JSX.Element;
    disabled?: boolean;
    visible?: boolean;
    isTablet?: boolean;
}

/** Component for the header's action (desktop and tablet mode). */
export default ({
    buttonId,
    title,
    disabled,
    icon,
    onClick,
    onClose,
    isTablet = false,
    visible = true,
}: IHeaderActionItemProps) => {
    if (!visible) {
        return <></>;
    }

    /**
     * Handles click and closes menu only in tablet mode.
     */
    const handleClick = () => {
        onClick();
        isTablet && onClose && onClose();
    };

    return isTablet ? (
        <MenuItem id={buttonId} onClick={handleClick} disabled={disabled}>
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            {title}
        </MenuItem>
    ) : icon ? (
        <IconButton disabled={disabled} title={title} onClick={onClick}>
            {icon}
        </IconButton>
    ) : (
        <button
            id={buttonId}
            onClick={handleClick}
            style={{
                color: 'black',
                height: '25px',
            }}
        >
            {title}
        </button>
    );
};
